var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"amber darken-2"},on:{"click":function($event){return _vm.template()}},slot:"activator"},[_c('v-icon',[_vm._v("subject")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }